import React, { useEffect } from "react";
import ReactDOM from "react-dom";

import {
    HawkSearch,
    QueryStringListener,
    SearchBox,
    FacetRail,
    Results,
    parseLocation,
    tConfig,
    TrackingEvent
} from "react-hawksearch";
import ContentTypeDynamicItem from "../components/ContentTypeDynamicItem";
import SitefinityResultItem from "../components/SitefinityResultItem";
import "react-hawksearch/dist/esm/react-hawksearch.css";

import { parseApiUrl, getDashboardUrl } from "../util/helper";

window.addEventListener("load", () => {
    var components = document.querySelectorAll(
        '[data-component="react-app-custom"]'
    );

    if (components) {
        components.forEach((component) => {
            var dashboardUrl = getDashboardUrl(
                component.getAttribute("data-hawksearch-base-api")
            );
            var apiUrlObj = parseApiUrl({
                searchApi: component.getAttribute("data-hawksearch-search-api"),
                autocompleteApi: component.getAttribute(
                    "data-hawksearch-autocomplete-api"
                ),
            });

            let hawkConfig = {
                clientGuid: component.getAttribute("data-client-guid"),
                dashboardUrl: dashboardUrl,
                searchPageUrl: location.pathname,
                indexName: component.getAttribute("data-index-name"),
                trackEventUrl: component.getAttribute('data-hawksearch-tracking-api'),
                indexNameRequired: false,
                facetTruncateLimit: parseInt(
                    component.getAttribute("data-facet-truncate-limit"),
                    10
                ),
                ...apiUrlObj,
            };

            var showSearchBox =
                component.getAttribute("data-show-searchbox") == "True";

            // pull the initial search from location
            let searchRequest = parseLocation(location, location.pathname);

            // on issuer pages, filter out issuerid for the initial api request
            if (location.href.includes("issuerid=")) {
                const {
                    FacetSelections: { issuerid, issuercik },
                    ...searchRequestWithoutIssuerIdProperty
                } = searchRequest;
                searchRequest = Object.assign(searchRequestWithoutIssuerIdProperty, {
                    FacetSelections: { issuercik },
                });
            }

            var trackingEvents = component.getAttribute('data-tracking-events');

            if (trackingEvents) {
                try {
                    hawkConfig.trackConfig = JSON.parse(trackingEvents);
                }
                catch (e) {
                    console.error(e);
                    console.error("Wrong Track event configuration");
                }
            }


            // used to set high level css class to hide facets with css based on page
            const hideAllFacets = location.href.includes("filingid=");

            const hideQueryFacet =
                location.href.includes("issuercik=") ||
                location.href.includes("firmid=") ||
                location.href.includes("engagementpartnermasterid=");

            if (component.getAttribute("data-json-params")) {
                try {
                    var additionalParameters = JSON.parse(
                        component.getAttribute("data-json-params")
                    );

                    hawkConfig.additionalParameters = additionalParameters;

                    if (additionalParameters.hasOwnProperty("CustomUrl")) {
                        searchRequest.CustomUrl = additionalParameters.CustomUrl.replace(
                            /\/$/,
                            ""
                        );
                        hawkConfig.CustomUrl = additionalParameters.CustomUrl.replace(
                            /\/$/,
                            ""
                        );
                    }
                } catch (e) { }
            }

            // apply translations if available
            var translationsEl = document.querySelectorAll(
                '[data-translations="react-translations"]'
            );

            if (translationsEl && translationsEl.length) {
                var translations = JSON.parse(translationsEl[0].innerHTML);

                tConfig.addResourceBundle(
                    "custom",
                    "translation",
                    translations,
                    true,
                    true
                );
                tConfig.changeLanguage("custom");
            }

            function App() {
                useEffect(() => {
                    TrackingEvent.track('pageload', { pageType: hawkConfig.CustomUrl ? 'landing' : 'custom' });
                }, []);
                return (
                    <HawkSearch config={hawkConfig} initialSearch={searchRequest}>
                        <QueryStringListener />
                        <div className="hawk">
                            <div className="hawk__header">
                                {showSearchBox ? <SearchBox /> : null}
                            </div>

                            <div
                                className={`hawk__body${hideAllFacets ? " hide-facets" : ""}${
                                    hideQueryFacet ? " hide-query-facet" : ""
                                    }`}
                            >
                                <FacetRail />

                                <Results ResultItem={ContentTypeDynamicItem} />
                            </div>
                        </div>
                    </HawkSearch>
                );
            }

            ReactDOM.render(<App />, component);
        });
    }
});
